import * as RadixSelect from '@radix-ui/react-select'
import { styled } from '../../../config'

export const Viewport = styled(RadixSelect.Viewport, {
  padding: '5px'
})
